import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LoadingOverlay from '../../LoadingOverlay';
import { useStores } from '../../stores/useStores';
import { randomDigits } from '../../utils';
import TrappingRunForm from './TrappingRunForm';

function AddTrappingRunModal(props) {
  const { authenticationStore } = useStores();
  const { addTrappingRun, ...rest } = props;

  const autoGeneratePasscode = props.customOptions?.autoGeneratePasscode;
  const propertiesSelector = props.customOptions?.propertiesSelector;
  const formOptions = props.customOptions?.form;
  const header = props.customOptions?.header;

  const generatePasscode = () => {
    if (!autoGeneratePasscode) return '';
    const length = 9;
    return randomDigits(length).toString();
  };

  return (
    <Modal backdrop='static' {...rest}>
      <Modal.Header closeButton>
        <h4>{header ? header : "Add Trapping Run"}</h4>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: '',
            description: '',
            passcode: generatePasscode(),
            properties: []
          }}
          validate={(values, props) => {
            const errors = {};

            if (!values.name) errors.name = 'Required';
            if (!values.passcode) errors.passcode = 'Required';

            return errors;
          }}
          onSubmit={(values, actions) => {
            fetch(`${process.env.REACT_APP_TRAPLOG_API_URL}api/trapping-runs`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authenticationStore.bearerToken}`,
                SeasonalDatabase: authenticationStore.selectedDatabase
              },
              body: JSON.stringify({
                name: values.name,
                description: values.description,
                passcode: values.passcode
              })
            })
              .then((res) => {
                if (res.ok) return res.json();
                else if (res.status === 401)
                  authenticationStore.refreshBearerToken();
                else throw Error(res.statusText);
              })
              .then((data) => {
                addTrappingRun(data);
                // Attach properties.
                fetch(
                  `${process.env.REACT_APP_PROPERTIES_API_URL}api/property-groups/${data.property_group_id}/attach-properties?with[]=properties&with[]=users.propertyRole&append[]=userProperty`,
                  {
                    method: 'PUT',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                      Authorization: `Bearer ${authenticationStore.bearerToken}`,
                      SeasonalDatabase: authenticationStore.selectedDatabase
                    },
                    body: JSON.stringify({
                      properties: values.properties.map(
                        (property) => property.value
                      )
                    })
                  }
                )
                  .then((res) => {
                    if (res.ok) return res.json();
                    else if (res.status === 401) props.refreshBearerToken();
                    else throw Error(res.statusText);
                  })
                  .catch((err) => {
                    if (process.env.NODE_ENV === 'development')
                      console.error(err);
                  })
                  .finally(() => {
                    rest.onHide();
                  });
              })
              .catch((err) => {
                if (process.env.NODE_ENV === 'development') console.error(err);
              })
              .finally(() => {
                actions.setSubmitting(false);
              });
          }}
        >
          {(props) => (
            <Fragment>
              <TrappingRunForm
                {...props}
                propertiesSelector={propertiesSelector}
                formOptions={formOptions}
              />
              <Button
                varient='primary'
                type='button'
                onClick={props.handleSubmit}
              >
                Submit
              </Button>
              {props.isSubmitting ? <LoadingOverlay /> : null}
            </Fragment>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

AddTrappingRunModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  addTrappingRun: PropTypes.func.isRequired,
  customOptions: PropTypes.object,
};

export default observer(AddTrappingRunModal);
